import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { commonRoutes } from 'constants/web-app-constants';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard {
  protected authService = inject(AuthService);
  protected router = inject(Router);

  public canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.checkUrlAllowed(state.url);
  }

  public canActivateChild(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.checkUrlAllowed(state.url);
  }

  public canLoad(route: Route): boolean | Observable<boolean> {
    return this.checkUrlAllowed(route.path);
  }

  public checkUrlAllowed(url: string): Observable<boolean> {
    return this.authService.isLoggedIn$().pipe(
      tap((loggedIn: boolean) => {
        if (loggedIn !== true) {
          this.authService.redirectUrl = url;
          this.router.navigate([commonRoutes.prelogin.home]);
        }
      }),
    );
  }
}
